import { RTDBPath, type ReleaseToggleNameTypes } from 'balus-common';
import { useSnapshot } from './hooks/useSnapshot';

/**
 * 指定されたリリーストグルの値を取得するカスタムフック
 * @param featureName
 * @returns
 */
// ts-unused-exports:disable-next-line
export const useReleaseToggle = (featureName: ReleaseToggleNameTypes): boolean => {
  const [value] = useSnapshot({
    path: RTDBPath.ApplicationConfig.releaseTogglePath(featureName),
    load: ({ snapshot }) => snapshot.val() || false,
  });

  return value;
};
